"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bans = exports.dbBan = exports.currentBans = exports.newBan = exports.ban = exports.banID = void 0;
const typebox_1 = require("@sinclair/typebox");
const string_1 = require("../options/string");
const user_1 = require("./user");
/**
 * Unique identifier type used to look up bans for a user when using path parameters.
 */
exports.banID = typebox_1.Type.Intersect([
    user_1.userID,
    typebox_1.Type.Object({
        banID: typebox_1.Type.String(Object.assign(Object.assign({}, string_1.uuid), { description: 'unique identifier of a ban' })),
    }),
]);
/**
 * Describes a ban entry used to track banned users. Used as the response
 * body of `/ban` endpoint queries in both the Backend and the Server.
 */
exports.ban = typebox_1.Type.Object({
    ID: typebox_1.Type.String(Object.assign(Object.assign({}, string_1.uuid), { description: 'unique identifier of the ban' })),
    reason: typebox_1.Type.String({
        description: 'Descriptive reason for the ban',
        example: 'Drove through the entrance gate.',
        maxLength: 65535,
    }),
    startDateTime: typebox_1.Type.String(Object.assign(Object.assign({}, string_1.dateTime), { description: 'start timestamp' })),
    endDateTime: typebox_1.Type.String(Object.assign(Object.assign({}, string_1.dateTime), { description: 'end timestamp' })),
});
/**
 * Defines the format of a new ban.
 */
exports.newBan = typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.ban, ['ID']),
    typebox_1.Type.Object({
        userID: typebox_1.Type.String(Object.assign(Object.assign({}, string_1.uuid), { description: 'identifier of the banned user' })),
    }),
]);
/**
 * A list of bans that is used when retrieving user's current bans.
 */
exports.currentBans = typebox_1.Type.Object({
    currentBans: typebox_1.Type.Array(exports.ban, {
        description: 'a list of user\'s current bans',
    }),
});
/**
 * Used by the Server to store ban records in the database.
 */
exports.dbBan = typebox_1.Type.Intersect([
    exports.ban,
    typebox_1.Type.Object({
        userID: typebox_1.Type.String(Object.assign(Object.assign({}, string_1.uuid), { description: 'identifier of the banned user' })),
    }),
]);
/**
 * A list of all bans.
 */
exports.bans = typebox_1.Type.Object({
    bans: typebox_1.Type.Array(exports.dbBan, {
        description: 'a list of all bans',
    }),
});
//# sourceMappingURL=ban.js.map